/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCumulativePercentageRequest } from '../models/CreateCumulativePercentageRequest';
import type { CumulativePercentageDto } from '../models/CumulativePercentageDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CumulativePercentageControllerService {
  /**
   * getAllCumulativePercentage
   * @returns CumulativePercentageDto OK
   * @throws ApiError
   */
  public static getAllCumulativePercentageUsingGet(): CancelablePromise<
    Array<CumulativePercentageDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cummulative-percentage',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createCumulativePercentage
   * @returns CumulativePercentageDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createCumulativePercentageUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateCumulativePercentageRequest;
  }): CancelablePromise<CumulativePercentageDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/cummulative-percentage',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getBySession
   * @returns CumulativePercentageDto OK
   * @throws ApiError
   */
  public static getBySessionUsingGet({
    sessionId,
  }: {
    /**
     * sessionId
     */
    sessionId: string;
  }): CancelablePromise<CumulativePercentageDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cummulative-percentage/by-session/{sessionId}',
      path: {
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getCumulativePercentageById
   * @returns CumulativePercentageDto OK
   * @throws ApiError
   */
  public static getCumulativePercentageByIdUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<CumulativePercentageDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cummulative-percentage/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateCumulativePercentage
   * @returns CumulativePercentageDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateCumulativePercentageUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: CreateCumulativePercentageRequest;
  }): CancelablePromise<CumulativePercentageDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/cummulative-percentage/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteCumulativePercentage
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCumulativePercentageUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/cummulative-percentage/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
